import { applyFilters, doRequest } from "./helpers";

export default class MetaDatasetService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/datasets`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async listStandalone(filters = null) {
    let path = "/meta_ad_account/datasets/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getStandalone(datasetPk) {
    return doRequest("GET", `/meta_ad_account/datasets/${datasetPk}`);
  }

  static async createStandalone(data) {
    return doRequest("POST", "/meta_ad_account/datasets/", { data });
  }

  static async updateStandalone(datasetPk, data) {
    return doRequest("PUT", `/meta_ad_account/datasets/${datasetPk}`, {
      data,
    });
  }

  static async deleteStandalone(datasetPk) {
    return doRequest("DELETE", `/meta_ad_account/datasets/${datasetPk}`);
  }

  static async sendStandaloneTestEvent(datasetPk, testEventCode) {
    return doRequest(
      "POST",
      `/meta_ad_account/datasets/${datasetPk}/test_event`,
      { data: { test_event_code: testEventCode } }
    );
  }

  static async getSwoogoEventDatasets(eventIds) {
    const path = applyFilters(
      { event_ids: eventIds.join(",") },
      "/meta_ad_account/datasets/swoogo_events/"
    );
    return doRequest("GET", path);
  }

  static async setSwoogoEventDataset(eventIds, metaDatasetId) {
    return doRequest("PUT", "/meta_ad_account/datasets/swoogo_events/dataset", {
      data: { event_ids: eventIds, meta_dataset_id: metaDatasetId },
    });
  }

  static async listSelectable() {
    return doRequest(
      "GET",
      "/meta_ad_account/datasets/swoogo_events/selectable_datasets"
    );
  }
}
